import type { ProductRequestSchemas } from "api-types";
import { http, HttpResponse } from "msw";

export const exampleFundsRequestInfo: ProductRequestSchemas.FundsRequestInfoResponse = {
  productRequestId: "7wfee2jwo125",
  isApplicationExpired: false,
  isKycRequired: true,
  isKycV2FlowEnabled: false,
  hasCustomerRequestedNewOffers: false,
  applicationExpiryDate: "January 10, 2024",
  applicationAmountInLowestDenomination: undefined,
  applicationCurrency: undefined,
  currentStep: "offers_available",
  alwaysOnOfferEnabled: false,
  isNewBusiness: false,
};

export const createFundsRequestHandler = (response: ProductRequestSchemas.FundsRequestInfoResponse) => {
  return http.get("/api/*/product-request/api/funds-request-info", () => HttpResponse.json(response));
};

export const getFundsRequestInfoHandler = createFundsRequestHandler({
  ...exampleFundsRequestInfo,
  currentStep: "in_review",
});
